import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { CHAT_TIME_RANGE } from "@/core/lib/date-time-ranges";

export const Route = createFileRoute("/_protected/history/")({
  validateSearch: z.object({
    time: z.enum(CHAT_TIME_RANGE).optional(),
    s: z.string().optional(),
  }),
});
